import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllLabelType = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [allLabelTypes, setAllLabelTypes] = useState([]);

  const getAllLabelType = () => {
    setLoading(true);
    axiosClient
      .get(`Product/Branch/Packaging/Print/GetAllLabelType`)
      .then(res => {
        if (res.status === 200) {
          // enqueueSnackbar(res.data?.message, { variant: 'success' });
          setAllLabelTypes(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getAllLabelType, loading, allLabelTypes];
};

export default useGetAllLabelType;
